import { SignupPayload } from '../../Views/Blocks/SignupBlock/classes/SignupPayload';
import { trackHeapEvent } from '../trackHeapEvent';
import { MarketingAutomationSubmissionType, Tracker } from './tracker';

const SUCCESSFUL_SIGNUP_EVENT_NAME: string =
  'Marketing - Hero Block - Sign up form' satisfies string;
const SUCCESSFUL_SIGNUP_EVENT_DETAILS: string =
  'Form interaction' satisfies string;

export class HeapTracker implements Tracker {
  fireSignupSuccess(
    signupData: SignupPayload,
    teamSize: number,
  ): Promise<void> {
    trackHeapEvent(SUCCESSFUL_SIGNUP_EVENT_NAME, {
      'Event details': SUCCESSFUL_SIGNUP_EVENT_DETAILS,
      Step: '4 Form submitted',
      'Business size': teamSize,
      'Promotional code': signupData.couponCode || '',
    });

    return Promise.resolve();
  }

  fireSignupStep(step: number): Promise<void> {
    trackHeapEvent(SUCCESSFUL_SIGNUP_EVENT_NAME, {
      'Event details': SUCCESSFUL_SIGNUP_EVENT_DETAILS,
      Step: step,
    });

    return Promise.resolve();
  }

  fireMarketingAutomationSubmission(
    type: MarketingAutomationSubmissionType,
  ): Promise<void> {
    const eventName = `Marketing - ${type} - Submission`;

    trackHeapEvent(eventName, {
      'Event details': eventName,
    });

    return Promise.resolve();
  }
}
